(function(){

  /**
   * Component for showing AST level completion for a student, including domain, cluster and standards breakdown
   */
  angular.module('edxComponents')
    .component('edxStudentLevelCompletion', {
      templateUrl: '/resources/components/standards-completion/student-level-completion.component/student-level-completion.component.html',
      controller: [
        'edxStandardsCompletionService',
        '$modal',
        'dblAnalyticsProvider',
        StudentLevelCompletionController],
      controllerAs: 'vm',
      bindings: {
        districtId: '<edxDistrictId',
        userId: '<edxUserId',
        astName: '<edxAstName',
        levelCode: '<edxLevelCode',
        analyticCategory: '@edxAnalyticCategory',
        hideAf: '<edxHideAfButtons'
      }
    });

  function StudentLevelCompletionController(
    standardsCompletionService,
    $modal,
    analyticService) {
    var vm = this;

    vm.$onChanges = $onChanges;
    vm.getProficiencyStatus = getProficiencyStatus;
    vm.isPseudoCluster = isPseudoCluster;
    vm.shouldAssignDomainLevel = shouldAssignDomainLevel;
    vm.openDomainModal = openDomainModal;
    vm.getStandardDisplayName = getStandardDisplayName;
    vm.areAfButtonsEnabled = areAfButtonsEnabled;

    vm.loading = false; // True while data is being loaded
    vm.levelCompletion = {}; // The level completion object

    if (!vm.analyticCategory) {
      vm.analyticCategory = 'Student Standards';
    }

    function $onChanges(changes) {
      if (
        changes.districtId ||
        changes.userId ||
        changes.astName ||
        changes.levelCode
      ) {
        _refreshLevelCompletion();
      }
    }

    function openDomainModal(domain) {
      analyticService.eventTrack('Domain Name Clicked', {
        category: vm.analyticCategory,
        label: domain.code
      });
      domain.standards = _.flatten(_.map(domain.clusters, function(cluster){return cluster.standards;}));
      vm.modal = $modal.open({
        templateUrl: 'resources/core/partials/domain-standard-modal.html',
        windowClass: 'domain-standard-modal',
        controller: 'DomainStandardModalController',
        backdrop: false,
        keyboard: true,
        resolve: {
          domain: function () {
            return domain;
          },
          grade: function() {
            return vm.levelCompletion;
          },
          selectedStandard: function () {}
        }});
    }

    /**
     * Convert percent complete into string usable with dbl-proficiency-indicator directive
     *
     * @param percent
     * @return {*}
     */
    function getProficiencyStatus(percent) {
      percent = Number(percent);
      if (percent >= 100.0) {
        return 'PROFICIENT';
      } else if (percent > 0.0) {
        return 'IN_PROGRESS';
      } else {
        return 'NOT_STARTED';
      }
    }

    /**
     * Reloads level completion info.
     * @private
     */
    function _refreshLevelCompletion() {
      if (
        vm.districtId &&
        vm.userId &&
        vm.astName &&
        vm.levelCode
      ) {
        vm.loading = true;
        standardsCompletionService.getLevelCompletionForStudent(
          vm.districtId,
          vm.userId,
          vm.astName,
          vm.levelCode
        ).then(function(levelCompletion){
          vm.levelCompletion = standardsCompletionService.collapsePseudoClustersInLevel(levelCompletion);
        }).catch(function(){
          vm.levelCompletion = {};
        }).finally(function(){
          vm.loading = false;
        });
      } else {
        vm.levelCompletion = {};
      }
    }

    /**
     * Proxy to service isPseudoCluster
     *
     * @param cluster The cluster to test
     * @return {boolean} True if cluster is a pseudo cluster
     */
    function isPseudoCluster(cluster) {
      return standardsCompletionService.isPseudoCluster(cluster);
    }

    /**
     * Determines if we should show an assign focus button for a domain.
     *
     * We only want to show AF button for domain if the domain only contains a pseudo cluster
     *
     * @param domain Domain to test
     * @return {boolean}
     */
    function shouldAssignDomainLevel(domain) {
      return domain.clusters.length === 1 && isPseudoCluster(domain.clusters[0]);
    }

    /**
     * Produce a value to display as the name for a standard.
     *
     * The dbl standard's names are not meaningful so we show short description instead.
     *
     * @param standard
     * @return {*}
     */
    function getStandardDisplayName(standard) {
      if (vm.astName === 'dbl' || vm.astName === 'uk_standards_2013') {
        return standard.shortDescription;
      } else {
        return standard.name;
      }
    }

    /**
     * Determines if Assign Focus buttons should be shown.
     *
     * @return {boolean}
     */
    function areAfButtonsEnabled() {
      return !vm.hideAf;
    }
  }
})();